import React, { useContext } from "react";

export const DragContext = React.createContext({ canDragState: false });
export const useDragContext = () => useContext(DragContext);
